import { Component, OnInit } 			                                      from '@angular/core';
import { Router, ActivatedRoute }                                 from '@angular/router';
import { first, timeout }                                         from 'rxjs/operators';
import { NgxSpinnerService }                                      from 'ngx-spinner';
import { Globals  }                                               from '../_helpers';

@Component({
  selector: 'student-start-practical',
  templateUrl: './thanks-page.component.html',
})

export class ThanksComponent implements OnInit{

	constructor(
        private route: ActivatedRoute,
        private router: Router,
        private globals: Globals,
        private spinner: NgxSpinnerService,    
    ) {}
    private sub: any;
    practical_id: number = 0;
    student_id: number = 0;
    returnUrl: string;    
    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
          this.practical_id = +params['id'];
          this.student_id = +params['stdid']
        });

/*        if((this.student_id == 0 || this.student_id == "") && (this.practical_id == 0 || this.practical_id == ""))
            this.router.navigateByUrl('/login');*/

        if(this.globals.isPracticalOver)
            this.router.navigateByUrl('/login'); 

        // get return url from route parameters or default to '/'
        this.returnUrl = '/';  

        this.showthanks();        
    }
    private showthanks()
    {
        this.globals.isPracticalOver = true; 
    }
    public gotoHome()
    {
        this.router.navigateByUrl('/login'); 
    }
}
